import { Pencil } from 'lucide-react';
import { DebriefFactSource } from '@momentum/types';
import type { EditableFact } from '../../shared/types';
import { IntegrationIcon } from '../../gather-facts-stage/components/IntegrationIcon';

interface FactCardProps {
  fact: EditableFact | null;
  manualFactLabel: string;
}

export function FactCard({ fact, manualFactLabel }: FactCardProps) {
  if (!fact) {
    return (
      <div className="w-full bg-slate-50 border border-slate-200 rounded-lg p-3 text-sm text-slate-400 italic">
        -
      </div>
    );
  }

  if (fact.source === DebriefFactSource.Manual) {
    return (
      <div className="w-full bg-slate-50 border border-slate-200 rounded-lg p-3 shadow-[inset_0_1px_2px_rgba(0,0,0,0.02)] flex items-start gap-2">
        <Pencil
          className="h-3.5 w-3.5 text-slate-400 mt-0.5 shrink-0"
          aria-hidden
        />
        <p className="text-sm text-slate-700 leading-relaxed flex-1 break-words">
          <span className="font-semibold text-slate-700 me-1">
            {manualFactLabel}
          </span>
          - {fact.description}
        </p>
      </div>
    );
  }

  return (
    <div className="w-full bg-slate-50 border border-slate-200 rounded-lg p-3 shadow-[inset_0_1px_2px_rgba(0,0,0,0.02)] flex items-start gap-2">
      <IntegrationIcon source={fact.source} className="mt-0.5 shrink-0" />
      <p className="text-sm text-slate-700 leading-relaxed flex-1 break-words">
        <span className="font-semibold text-slate-800 me-1">{fact.title}</span>-{' '}
        {fact.description}
      </p>
    </div>
  );
}
